import type { Editor } from '@tiptap/core';

import { ETiptapAlignmentSelectorKey, ETiptapSelectorKey } from '../../types/tiptap.types';
import { IMAGE_NODE_NAME } from '../../tiptap/nodes/image/constants';

export const isInCell = (editor: Editor): boolean => editor.isActive('tableCell') || editor.isActive('tableHeader');

export const isInList = (editor: Editor): boolean =>
  editor.isActive('bulletList') || editor.isActive('orderedListWithStart') || editor.isActive('taskList');

/** Lists in a table cell carry the alignment on the cell, so the whole list moves as one block. */
export const getHorizontalAlignmentState = (editor: Editor): ETiptapAlignmentSelectorKey => {
  if (isInList(editor) && isInCell(editor)) {
    const cellType = editor.isActive('tableHeader') ? 'tableHeader' : 'tableCell';
    const cellAlign = editor.getAttributes(cellType).align;

    return Object.values(ETiptapAlignmentSelectorKey).includes(cellAlign)
      ? cellAlign
      : ETiptapAlignmentSelectorKey.LEFT;
  }

  if (editor.isActive(IMAGE_NODE_NAME)) {
    const imageAlign = editor.getAttributes(IMAGE_NODE_NAME).textAlign;
    return Object.values(ETiptapAlignmentSelectorKey).includes(imageAlign)
      ? imageAlign
      : ETiptapAlignmentSelectorKey.LEFT;
  }

  return (
    Object.values(ETiptapAlignmentSelectorKey).find((key) => editor.isActive({ textAlign: key })) ||
    ETiptapAlignmentSelectorKey.LEFT
  );
};

export const canAlignHorizontally = (editor: Editor): boolean =>
  !editor.isActive(ETiptapSelectorKey.HEADING) &&
  (editor.isActive(IMAGE_NODE_NAME) ||
    editor.can().chain().focus().setTextAlign(ETiptapAlignmentSelectorKey.JUSTIFY).run());
